Switch landing page:
<ng-container *ngFor="let variant of variants; let i = index;">
  <a class="mx-2 {{variant == currentVariant ? 'active' : ''}}" (click)="SelectVariant(i)">{{variant}}</a><br />
</ng-container>
